/**
 * Normalizes URLs for Open Graph / WhatsApp (requires absolute https URLs).
 */
export function toAbsoluteUrl(
  url: string | undefined | null,
  baseOrigin: string
): string {
  const origin = (baseOrigin || '').replace(/\/$/, '') || window.location.origin;
  if (!url || !String(url).trim()) {
    return `${origin}/icon.svg`;
  }
  const u = String(url).trim();
  if (/^https:\/\//i.test(u)) {
    return u;
  }
  if (/^http:\/\//i.test(u)) {
    return `https://${u.slice(7)}`;
  }
  if (u.startsWith('//')) {
    return `https:${u}`;
  }
  if (u.startsWith('/')) {
    return `${origin}${u}`;
  }
  return `https://${u}`;
}
